import { clsx } from "clsx";
import { type CSSProperties, forwardRef, type ReactNode } from "react";

import style from "./TriggerButtonGroup.module.css";

export interface TriggerButtonGroupProps {
  children: ReactNode;
  vertical?: boolean;
  style?: CSSProperties;
  className?: string;
}

const TriggerButtonGroup = forwardRef<HTMLDivElement, TriggerButtonGroupProps>(function TriggerButtonGroup(props, ref) {
  return (
    <div
      className={clsx(style.group, props.className, { [style.vertical]: props.vertical })}
      style={props.style}
      ref={ref}
    >
      {props.children}
    </div>
  );
});

export { TriggerButtonGroup };
